module.exports = __webpack_public_path__ + "images/柏纳长图_10-4.jpg?v=3dbf12c8";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_10-4.jpg
 ** module id = 154
 ** module chunks = 1 2
 **/